import {
	AppstoreOutlined,
	HomeOutlined,
	TeamOutlined,
	UserOutlined,
} from '@ant-design/icons';
import type { ReactNode } from 'react';

/** A tab within a page, addressed as a further path segment. */
export type NavTab = {
	/** Segment under the page's path, e.g. 'assignments' → /apps/assignments. */
	segment: string;
	label: string;
};

export type NavItem = {
	/** Breadcrumb segment key; '' is the index (Home) route. */
	segment: string;
	/** Absolute path used as the sidebar menu key and breadcrumb link. */
	path: string;
	label: string;
	icon: ReactNode;
	/** Tabs the page splits into, if any. The first is its default. */
	tabs?: NavTab[];
};

/**
 * Apps' tabs, in display order. The page builds its tab bar from this and the
 * breadcrumbs take their labels from it, so the two can't drift apart. The
 * first entry is the default: /apps redirects to it.
 */
export const APPS_TABS: NavTab[] = [
	{ segment: 'assignments', label: 'App assignments' },
	{ segment: 'permissions', label: 'High level permissions' },
];

/**
 * Single source of truth for the app's navigable pages: the sidebar menu and
 * breadcrumb labels are both derived from this list. (Route components are
 * wired in ./index.ts, which imports the page modules.)
 */
export const navItems: NavItem[] = [
	{ segment: '', path: '/', label: 'Home', icon: <HomeOutlined /> },
	{
		segment: 'apps',
		path: '/apps',
		label: 'Apps',
		icon: <AppstoreOutlined />,
		tabs: APPS_TABS,
	},
	{ segment: 'principals', path: '/principals', label: 'Principals', icon: <UserOutlined /> },
	{ segment: 'users', path: '/users', label: 'Users', icon: <TeamOutlined /> },
];
